import type { GetLeadDetailsQuery } from '@graphql/__generated__/graphql';

type Lead = NonNullable<GetLeadDetailsQuery['leads_by_pk']>;

export const getLeadMapProperty = (lead: Lead) =>
  lead.property ??
  (lead.origin_enquiry_id != null &&
  lead.appraisal_property_lat != null &&
  lead.appraisal_property_lng != null
    ? {
        id: lead.id,
        lat: lead.appraisal_property_lat,
        lng: lead.appraisal_property_lng,
        country_code: lead.appraisal_property_country_code,
      }
    : null);
